import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../services/general.service';
import { GroupService } from '../../services/group.service';
import { ProvidersService } from '../../services/providers.service';
import {ModalConfirmComponent} from '../../modal-confirm/modal-confirm.component';

import * as decode from 'jwt-decode';
import * as XLSX from 'xlsx';
import {DatePipe} from '@angular/common';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {COMMA, ENTER, SPACE} from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { saveAs } from 'file-saver/FileSaver';
import { OrderDetailComponent } from '../order-detail/order-detail.component';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from 'ng2-translate';

@Component({
  selector: 'app-approve',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.scss']
})
export class ApproveComponent implements OnInit {
  userId: any;
  userToken: any;
  listOrders: any = [];
  temp: any = [];
  load = true;
  expanded: any = {};
  @ViewChild('table', { static: false }) table: any;

  myControl = new FormControl();
  filteredOptions: Observable<string[]>;
  providerActive = 'hide';
  providersList=[];
  data: any = {};
  isExternal;
  perfilId;
  arrOc = [];
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA, SPACE];
  loadBtn = false;
  listSocieties = [];
  idTipo : string = "3";
  msgRequired:any = '';
  //Tipos de ordenes
  //1 aprobacion de ordenes cerradas extranjeros, cualquirea puede aprobar
  //2 aprobacion de ordenes abiertas extranjeros, cualquiera puede aprobar
  //3 aprobacion de servicios, solo el autorizador que este asocieado al CC puebe aprobar.

  showContent:boolean=false;
  constructor(
    private toastr: ToastrService,
    public dialog: MatDialog,
    private gralService: GeneralService,
    private groupService: GroupService,
    private provService: ProvidersService,
    private route: ActivatedRoute,
    private translate: TranslateService
  ) {
    let lang = translate.currentLang;
    console.log("langu "+lang);
    this.userToken =  localStorage.getItem('G13xTfsdf234TVsd23513ffdgFdf2352');
    const d = this.userToken.split('Bearer ');
    const tokenPayload = decode(d[1]);

    this.userId = tokenPayload.Id;

    var idTipo = this.route.snapshot.paramMap.get('idTipo');
    console.log("idTipo %o",this.idTipo);
    if( idTipo ){
      this.idTipo = idTipo;
    }


    if( this.idTipo == "1")
    {
      gralService.changeTextHead('APPROVECLOSEORDERS');
    }
    if( this.idTipo == "2")
    {
      gralService.changeTextHead('APPROVEOPENORDERS');
    }
    if( this.idTipo == "3" )
    {
      gralService.changeTextHead('APPROVESERVICESORDERS');
    }

    //this.getOrders();

    this.isExternal = tokenPayload.EsUsuarioExterno;
    this.perfilId = tokenPayload.IdPerfil;
    this.providerActive = (this.perfilId == '3' && this.isExternal )? 'hide': 'show';
    this.getSocieties();
  }

  ngOnInit() {
    this.loadProviders();
    this.filteredOptions = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

      this.data.FechaFin = new Date();



  }

  /* ********************* filtros ************** */
  search(){
    console.log(" required "+this.translate.currentLang);
    let msgRequired = "Favor de ingresar todos los campos";
    if(this.translate.currentLang == "es"){
       msgRequired = "Favor de ingresar todos los campos";
    }else if(this.translate.currentLang == "en"){
       msgRequired = "All fields are required";
    }
    this.data.Proveedor = this.arrOc.join();
    
    if(!this.data.Sociedad || !this.data.FechaInicio || !this.data.FechaFin){
      this.toastr.error(msgRequired, 'Error');
      return;
    }

    this.listOrders = [];
    this.loadBtn = true;
    const datePipe = new DatePipe('en-US');
    const dateinit = this.data.FechaInicio;
    const dateend = this.data.FechaFin;
    const params = {
      FechaFin: datePipe.transform(dateend, 'yyyy-MM-dd'),
      FechaInicio: datePipe.transform(dateinit, 'yyyy-MM-dd'),
      Proveedor: this.data.Proveedor,
      Sociedad: this.data.Sociedad,
      usuario: this.userId,
      IdUsuario: this.userId,
      idTipo : this.idTipo
    };


    this.provService.getServicePending(params, this.userToken).then((data) => {

      this.loadBtn = false;
      this.listOrders = data['Entidades'];
      this.temp = data['Entidades'];
      this.showContent = true;
      if(this.listOrders.length == 0){
        let title = "Sin datos";
        let msgRequired = "No se encontraron resultados para su busqueda";
        if(this.translate.currentLang == "es"){
          title = "Sin datos";
          msgRequired = "No se encontraron resultados para su busqueda";
        }else if(this.translate.currentLang == "en"){
          msgRequired = "No results for your search";
          title = "No data";
        }
        this.toastr.success(msgRequired, title);
        return false;
      }else{
        //this.reorderDataExportExcel(this.listOrders);
      }

    }, (err) => {
        console.log(err);
        this.listOrders = null;
        this.temp = null;
        this.loadBtn = false;
        this.toastr.error('--', 'Error');// ver como esta url regresa los errores
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }

    });
  }

  toExportFileName(excelFileName: string): string {
    return `${excelFileName}_export_${new Date().getTime()}.xlsx`;
  }

  public exportAsExcelFile(): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.listExcel);
    const workbook: XLSX.WorkBook = {Sheets: {'data': worksheet}, SheetNames: ['data']};
    XLSX.writeFile(workbook, this.toExportFileName('aprobacion_servicios'));
  }

  listExcel =  [];
  reorderDataExportExcel(lista){
    this.listExcel =  [];

    for(let i = 0; i < lista.length; i++){
      let contTable = lista[i].RecepcionFactura;

      let params = {
          "Serie": contTable.Serie,
          "Folio": contTable.Folio,
          "RFC Emisor" : contTable.RFCEmisor,
          "Número de proveedor" : contTable.NumProveedor,
          "Fecha de emisión": contTable.FechaEmision,
          "Fecha de carga" : contTable.FechaCarga,
          "Estatus": contTable.EstatusProcesoFactura.Descripcion,
          "Doc. Factura":  (lista[i].Resultado && lista[i].Resultado.InvoiceDocumentMiro) ? lista[i].Resultado.InvoiceDocumentMiro: 0 ,
          "Año Doc. Factura": (lista[i].Resultado && lista[i].Resultado.InvoiceDocumentYearMiro) ?  lista[i].Resultado.InvoiceDocumentYearMiro :0
      }
      this.listExcel.push(params);
    }
  }

  disabledProv(){
    let resp = false;

    if(this.data.Sociedad){
      const society = this.listSocieties.find(x => x.NoSociedad == this.data.Sociedad);
      if(society.NumProveedor){
        resp = true;

      }
    }
    return resp;
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our fruit
    if ((value || '').trim()) {
      this.arrOc.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(oc): void {
    const index = this.arrOc.indexOf(oc);
    if (index >= 0) {
      this.arrOc.splice(index, 1);
    }
  }

  paste(event: ClipboardEvent): void {
    event.preventDefault();
    event.clipboardData
      .getData('Text')
      .split(/;|,|\n/)
      .forEach(value => {
        const string = value.split(' ');
        if(string){
          string.forEach(val => {
            if(val.trim()){
              this.arrOc.push(val.trim());
            }
          });
        }else{
          if(value.trim()){
            this.arrOc.push(value.trim());
          }
        }
      })
  }

  addProveedorSearch(option){

    let value = this.myControl.value;
    if ((value || '').trim()) {
      let proveedor = value.split(' - ');
      this.arrOc.push(proveedor[0]);
    }

    this.myControl.setValue('');
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.providersList.filter(option => option.toLowerCase().includes(filterValue));
  }

  loadProviders(){
    this.provService.getProvidersNum(this.userToken).then((res:any)=>{
      this.providersList = res.Entidades;
    });
  }

  getSocieties(){
    this.provService.getSociedades(this.userId, this.userToken).then((data) => {
      this.loadBtn = false;
      if(data['EsValido']){
        this.listSocieties = data['Entidades'];
        if(this.listSocieties.length == 1){
          this.data.society = this.listSocieties[0].NoSociedad;
          this.data.Sociedad = this.listSocieties[0].NoSociedad;
          this.selectSociety(0);

        }
      }else{
        this.listSocieties = null;
      }
    }, (err) => {
      console.log(err);
      this.loadBtn = false;
      this.listSocieties = null;
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });
  }

  selectSociety(pos){
    if(this.perfilId==3){
      let List = this.listSocieties;
      this.arrOc = [];
      this.arrOc.push(List[pos].NumProveedor);
    }
  }
  /* ********************* filtros ************** */

  detail(GuidRecepcionFactura){
    this.provService.getCloseOrder(GuidRecepcionFactura, this.userToken).then((data) => {
      const dialogDetail =this.dialog.open(OrderDetailComponent, {
        minWidth: '80%',
        position: {
          top: '6%'
        },
        data: { type: 'detail', info: data['Entidad'], id: GuidRecepcionFactura, approve: true, userId: this.userId }
      });

      dialogDetail.afterClosed().subscribe(result=>{
        if(result){
          this.search();
        }
      });

    }, (err) => {
      console.log(err);
      this.toastr.error('--', 'Error');// ver como esta url regresa los errores
      if(err.status == 401){
        this.gralService.actDeacUser(false);
      }
    });

  }
}
